import { ExternalLink } from 'lucide-react';
import { resolveImageUrl } from '@/components/ImageUploader';
import { formatCOP, formatDate } from '@/lib/format';

const PLACEHOLDER = '/categorias/accesorios-800.webp';

export const PromoOfferCard = ({ offer }) => {
  const img = resolveImageUrl((offer.images || [])[0]) || PLACEHOLDER;
  const external = offer.cta_url && /^https?:\/\//.test(offer.cta_url);
  return (
    <article className="group flex flex-col border border-slate-200 bg-white transition-shadow duration-200 hover:shadow-lg" data-testid={`promo-offer-card-${offer.offer_id}`}>
      <div className="relative aspect-[4/3] overflow-hidden bg-slate-100">
        <img src={img} alt={offer.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105" />
        {offer.promo_label && (
          <span className="absolute left-3 top-3 bg-orange-600 px-2 py-1 text-[11px] font-black uppercase tracking-wide text-white" data-testid="promo-offer-label">{offer.promo_label}</span>
        )}
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="font-display text-lg font-black tracking-tight text-slate-900" data-testid="promo-offer-title">{offer.title}</h3>
        {offer.description && <p className="mt-1 line-clamp-3 text-sm text-slate-600">{offer.description}</p>}
        {offer.price != null && <div className="mt-3 text-xl font-black text-slate-900" data-testid="promo-offer-price">{formatCOP(offer.price)}</div>}
        {offer.ends_at && <div className="mt-1 text-xs text-slate-500">Válida hasta el {formatDate(offer.ends_at)}</div>}
        {offer.cta_url && (
          <a href={offer.cta_url} target={external ? '_blank' : undefined} rel={external ? 'noopener noreferrer' : undefined}
            className="mt-4 inline-flex items-center justify-center gap-2 bg-slate-900 px-4 py-2 text-sm font-bold text-white transition-colors hover:bg-orange-600"
            data-testid={`promo-offer-cta-${offer.offer_id}`}>
            {offer.cta_label || 'Más información'} <ExternalLink className="h-4 w-4" />
          </a>
        )}
      </div>
    </article>
  );
};
